
/* jshint bitwise : false */
/* eslint no-bitwise: 0 */
angular.module('filters')
    .filter('formatTime', ($translate, Util) => (diffTime, actionDone, actionFailed, format) => {

        format = format === 'short' ? '_short' : '';

        diffTime = Util.getElapsedMilli(diffTime);

        actionFailed = !actionFailed ?
            $translate.instant('cw.general.time.unknown') :
            $translate.instant(actionFailed);
        actionDone = !actionDone ? '' : $translate.instant(actionDone);

        if (!diffTime) {

            return actionFailed;

        }

        if (diffTime < 0) {

            diffTime = 0;

        }

        const seconds = Math.floor(diffTime / 1000);
        let interval = Math.floor(seconds / 31536000);

        const timeAgo = (function getTimeAgo() {

            if (interval >= 2) {

                return ['years_ago', ~~interval];

            } else if (interval >= 1) {

                return ['year_ago', ~~interval];

            }

            interval = seconds / 2592000;
            if (interval >= 2) {

                return ['months_ago', ~~interval];

            } else if (interval >= 1) {

                return ['month_ago', ~~interval];

            }

            interval = seconds / 604800;
            if (interval >= 2) {

                return ['weeks_ago', ~~interval];

            } else if (interval >= 1) {

                return ['week_ago', ~~interval];

            }

            interval = seconds / 86400;
            if (interval >= 2) {

                return ['days_ago', ~~interval];

            } else if (interval >= 1) {

                return ['day_ago', ~~interval];

            }

            interval = seconds / 3600;
            if (interval >= 2) {

                return ['hours_ago', ~~interval];

            } else if (interval >= 1) {

                return ['hour_ago', ~~interval];

            }

            interval = seconds / 60;
            if (interval >= 2) {

                return ['minutes_ago', ~~interval];

            } else if (interval >= 1) {

                return ['minute_ago', ~~interval];

            }

            return ['just_now', seconds];

        }());

        return `${actionDone} ${$translate.instant(
            `cw.general.time.${timeAgo[0]}${format}`,
            { interval: timeAgo[1] },
        )}`;

    });



// WEBPACK FOOTER //
// ./scripts/common/filters/formatTime.js